import React, { useRef } from "react";
import { ExpandCard } from "@components";
import { ExpandCardRef } from "@components/ExpandCard";
import { BalanceAccountWithTransactions, ModuleSetting } from "@models";
import BalanceAccountCardHeader from "./BalanceAccountCardHeader";
import BalanceAccountDetails from "./BalanceAccountDetails";
import { checkAssociatedModuleSetting } from "./util";

type Props = {
	balanceAccount: BalanceAccountWithTransactions;
	moduleSettings: ModuleSetting[];
	className?: string;
	isInitiallyExpanded?: boolean;
};

export default function BalanceAccountCard(props: Props) {
	const { balanceAccount, isInitiallyExpanded, moduleSettings } = props;

	const expandCardRef = useRef<ExpandCardRef>(null);

	const hasAssociatedModuleSetting = checkAssociatedModuleSetting(
		balanceAccount,
		moduleSettings
	);

	const header = (
		<BalanceAccountCardHeader
			balanceAccount={balanceAccount}
			hasAssociatedModuleSetting={hasAssociatedModuleSetting}
		/>
	);

	const collapseCard = () => {
		expandCardRef.current?.collapse();
	};

	const onCloseEditMode = () => {
		collapseCard();
		return true;
	};

	return (
		<>
			<ExpandCard
				className={props.className}
				testId={"balanceAccountCard-" + balanceAccount.balanceAccountId}
				css={`
					margin-bottom: 10px;
				`}
				header={header}
				ref={expandCardRef}
				isInitiallyExpanded={isInitiallyExpanded}
				onCollapse={() => onCloseEditMode()}
			>
				<BalanceAccountDetails
					balanceAccount={balanceAccount}
					hasAssociatedModuleSetting={hasAssociatedModuleSetting}
				/>
			</ExpandCard>
		</>
	);
}
